<script setup lang="ts">

import GFBSPlanetBuildings
  from '@/components/Sections/Government/Finances/BalanceSheetDetails/Planets/GFBSPlanetBuildings.vue'
</script>

<template>
  <div>
      <GFBSPlanetBuildings/>
  </div>
</template>

<style scoped lang="scss">

</style>